import moment from 'moment'

export default () => ({
  viewType: 'card',
  isLoading: false,
  isLoadingMore: false,
  isControls: false,
  isImageUploading: false,
  isModalFormLoading: false,
  modalForm: {
    active: false,
    mode: null,
    message: null,
    showContent: true,
  },
  collection: [],
  formErrors: [],
  form: {
    page: 1,
    perPage: 10,
    priceSort: 'ascending',
  },
  filters: {
    locations: [],
    dateFrom: null,
    dateTo: null
  },
  filtersErrors: [],
  isFiltersApplied: true,
  filtersCollection: {
    locations: [],
    date: []
  },
  visibilitySettingsType: 'dateOnly',
  editableNowSaleId: null,
  editForm: {
    serviceId: 1,
    rooms: {
      0: {
        adults: 2,
        children: 0,
        ages: []
      }
    },
    placeFrom: {
      name: null,
      slug: null,
      badge: null,
      code: null
    },
    placeTo: {
      name: null,
      slug: null,
      badge: null,
      code: null
    },
    searchDate: null,
    extraDays: 0,
    duration: 7,
    description: null,
    comment: null,
    imageSrc: null,
    imageId: null,
    image: null,
    validityFrom: moment().add(1, 'day').format('DD.MM.YYYY'),
    validityTo: moment().add(7, 'days').format('DD.MM.YYYY'),
    isActive: 1
  },
  editFormErrors: [],
  pagination: {
    page: 1,
    perPage: 10,
    lastPage: 1,
    total: 10
  },
  dictionaries: {
    currencies: []
  }
})